module.exports = __webpack_public_path__ + "img/yt-joe-avaxusdc.dd434c3a.png";